import React, { useState, useRef, useLayoutEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Tooltip } from '../Tooltip';
import { debounce } from '../Utils/helper';
import moduleStyles from '@dtsl/css-breadcrumb/dist/index.module.css';
import Slash2 from '@dtsl/icons/dist/icons/react/Slash2';
function BreadcrumbItem(props) {
  const {
    breadcrumb = {},
    indexSelected = 0,
    isLastItem = false,
    onSelect = () => {}
  } = props;
  const {
    index,
    url = '#',
    label,
    disabled,
    target = '_self',
    className = '',
    styles = {}
  } = breadcrumb;
  const breadcrumbLabelRef = useRef(null);
  const breadcrumbItemClasses = classNames({
    [moduleStyles['sib-breadcrumb-item']]: true,
    [moduleStyles['sib-breadcrumb-item__selected']]: isLastItem,
    [className]: !!className
  });
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const checkOverflow = () => {
    if (breadcrumbLabelRef?.current) {
      const {
        offsetWidth,
        scrollWidth
      } = breadcrumbLabelRef?.current || {};
      setIsTooltipVisible(offsetWidth < scrollWidth);
    }
  };
  const {
    execDebounce: handleResize,
    cancelDebounce
  } = debounce(checkOverflow, 300);
  useLayoutEffect(() => {
    checkOverflow();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      cancelDebounce();
    };
  }, [breadcrumbLabelRef.current]);
  return /*#__PURE__*/React.createElement("li", {
    className: moduleStyles['sib-breadcrumb-items'],
    disabled: disabled,
    key: index,
    style: styles
  }, /*#__PURE__*/React.createElement("a", {
    href: url,
    rel: "noreferrer",
    target: target,
    ref: breadcrumbLabelRef,
    disabled: disabled,
    onClick: event => onSelect(breadcrumb, index, event),
    className: breadcrumbItemClasses,
    "aria-current": indexSelected == index ? 'page' : isLastItem ? 'page' : null
  }, isTooltipVisible ? /*#__PURE__*/React.createElement(Tooltip, {
    text: label,
    placement: "bottom-start"
  }, /*#__PURE__*/React.createElement("span", null, label)) : label), !isLastItem ? /*#__PURE__*/React.createElement(Slash2, {
    className: moduleStyles['sib-breadcrumb-item__separator']
  }) : '');
}
BreadcrumbItem.propTypes = {
  onSelect: PropTypes.func,
  breadcrumb: PropTypes.shape({
    url: PropTypes.string,
    target: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    index: PropTypes.number
  }),
  indexSelected: PropTypes.number,
  isLastItem: PropTypes.bool
};
export default BreadcrumbItem;